import React, { useEffect, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import ReactTable from 'components/ReactTable/ReactTable';
import { Link, useNavigate } from 'react-router-dom';
import { wsFindBy } from 'services/WService';
import { Add, Delete, PictureAsPdf, Restore, Visibility } from '@material-ui/icons';
import Badge from 'components/Badge/Badge';
import { Box, Tooltip } from '@material-ui/core';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import RegularButton from 'components/CustomButtons/Button';
import { ConstantPermissions } from 'contexts/useConstant';
import { wsUpdate, wsRemove } from 'services/WService';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 150 },
  { Header: 'Procesado', accessor: 'processed', width: 120 },
  { Header: 'Producto a convertir', accessor: 'ItemName', width: 230 },
  { Header: 'Cantidad', accessor: 'Quantity', width: 110 },
  { Header: 'Producto convertido', accessor: 'ItemName2', width: 230 },
  { Header: 'Cantidad', accessor: 'Quantity2', width: 110 },

  { Header: 'Valorizado', accessor: 'GTotal', width: 120 },
  { Header: 'Zona', accessor: 'zone', width: 140 },
  { Header: 'Almacén', accessor: 'WhsName', width: 140 },
  { Header: 'Creado por', accessor: 'created_user_name' },
  { Header: 'Validado por', accessor: 'validated_user_name' },
  { Header: 'Aprobado por por', accessor: 'approved_user_name' },
  { Header: 'Fecha creación', accessor: 'created_at', width: 200 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function ConvertionList() {
  const [convertions, setConvertions] = useState([]);
  const [filters, setFilters] = useState({});
  const [processing, setProcessing] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  const navigate = useNavigate();

  async function listConvertions() {
    setDataLoading(true);
    let data = { ...filters };
    let res = await wsFindBy('logi/convertion', data);
    setDataLoading(false);
    if (res.success) {
      setConvertions(res.data);
    }
  }

  async function restoreSapCount(convertion) {
    setDataLoading(true);
    let res = await wsUpdate(`logi/convertion/${convertion.id}/restore-sap-count`);
    setDataLoading(false);
    if (res.success) {
      // setConvertions(convertions => {
      //   let newConvertions = [...convertions];
      //   let index = newConvertions.findIndex(convertion => convertion.id === res.data.id);
      //   if(index !== -1){
      //     newConvertions[index] = res.data;
      //   }
      //   return newConvertions;
      // });
      listConvertions();
    }
  }

  async function destroyConvertion(convertion) {
    if (!window.confirm('Eliminar conversión?')) {
      return;
    }
    setDataLoading(true);
    setProcessing(true);
    let res = await wsRemove('logi/convertion', convertion.id);
    setDataLoading(false);
    if (res.success) {
      await listConvertions();
      window.alert(res.message);
      setProcessing(false);
    }
  }

  useEffect(() => {
    if (Object.keys(filters).length === 0) return;
    listConvertions();
  }, [filters]);

  return (
    <CardContainer
      title={(
        <>
          Conversiones {dataLoading && <LoadingSpinner />}
        </>
      )}
      onClick={() => navigate('0')}
      iconColor="success"
      permission={ConstantPermissions.LOGI_CONVERTIONS_STORE}
      icon={<Add />}
    >
      
      {/* Filtros */}
      <FilterCustom
        zone
        provider
        dateRange
        warehouse="N"
        getFilter={setFilters}
        // Estado
        state
        nameState="state_migrate"
        optionValues={['D', 'V', 'X', 'P']}
        nameOptions={['Borrador', 'Validado', 'Procesando', 'Completo']}
      />
      <ReactTable
        excelName="conversiones"
        defaultWidth={2000}
        formatDate="DD-MM-YYYY HH:mm"
        columns={columns}
        data={convertions.map((convertion, index) => {
          return {
            num: (
              <Box display="flex" alignItems="center">
                {index + 1}
                <AllowedGuard permission={ConstantPermissions.LOGI_CONVERTIONS_SHOW}>
                  <RegularButton justIcon round simple>
                    <Link to={`${convertion.id}`}>
                      <Visibility />
                    </Link>
                  </RegularButton>
                  <RegularButton
                    justIcon
                    round
                    simple
                    color="info"
                    // onClick={() => getUrlPDF(item.id)}
                    onClick={() => alert('En proceso...')}
                    disabled={convertion.DocEntry === null}
                  >
                    <PictureAsPdf />
                  </RegularButton>
                </AllowedGuard>
                {convertion.state_migrate === 'D' && (
                  <AllowedGuard permission={ConstantPermissions.LOGI_CONVERTIONS_DESTROY}>
                    <RegularButton
                      justIcon
                      round
                      simple
                      color="danger"
                      disabled={processing}
                      onClick={() => destroyConvertion(convertion)}
                    >
                      <Delete />
                    </RegularButton>
                  </AllowedGuard>
                )}
              </Box>
            ),
            processed:
              convertion.sapAnnuled !== null ? (
                <Badge color={convertion.sapAnnuled === 'P' ? 'warning' : 'danger'}>
                  {convertion.sapAnnuled === 'P' ? 'Procesando anulación' : 'Anulado'}
                </Badge>
              ) : parseInt(convertion.sapCount) === 3 &&
                convertion.sapError !== null &&
                convertion.DocEntry === null ? (
                <>
                  <Tooltip title={convertion.sapError}>
                    <div>
                      <Badge color="danger">¡Error!</Badge>
                    </div>
                  </Tooltip>
                  <RegularButton
                    color="warning"
                    round
                    justIcon
                    simple
                    onClick={() => {
                      restoreSapCount(convertion);
                    }}
                  >
                    <Restore />
                  </RegularButton>
                </>
              ) : (
                <Badge color={convertion.DocEntry === null ? 'warning' : 'success'}>
                  {convertion.DocEntry === null ? 'No' : 'Si'}
                </Badge>
              ),
            ItemName: convertion.from_product.ItemName,
            Quantity: convertion.father_quantity,
            ItemName2: convertion.to_product.ItemName,
            Quantity2: convertion.PlannedQty,
            GTotal: 0,
            zone: convertion.zone.description,
            WhsName: convertion.warehouse.WhsName,
            created_user_name: convertion.created_user?.name ?? '-',
            validated_user_name: convertion.validated_user?.name ?? '-',
            approved_user_name: convertion.approved_user?.name ?? '-',
            created_at: convertion.created_at,
          };
        })}
      />
    </CardContainer>
  );
}

export default ConvertionList;
